export const applicationReviewsKey = "applicationReviews";
